import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Shipping as ShippingIcon } from "@faire/web/slate/icons/foundation/Shipping";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { ChangeShippingAddressIA } from "../instantAnswers/ordersAndShipping-changeShippingAddress";
import { CreateReturnIA } from "../instantAnswers/ordersAndShipping-createReturn";
import { DutiesInvoiceIA } from "../instantAnswers/ordersAndShipping-dutiesInvoice";
import { EoriDetailsIA } from "../instantAnswers/ordersAndShipping-eoriDetails";
import { EstimatedShipDateIA } from "../instantAnswers/ordersAndShipping-estimatedShipDate";
import { ExtendReturnIA } from "../instantAnswers/ordersAndShipping-extendReturn";
import { HowDutiesWorkIA } from "../instantAnswers/ordersAndShipping-howDutiesWork";
import { ItemDelayedIA } from "../instantAnswers/ordersAndShipping-itemDelayed";
import { PoBoxIA } from "../instantAnswers/ordersAndShipping-poBox";
import { ReportDamagedItemIA } from "../instantAnswers/ordersAndShipping-reportDamagedItem";
import { ReportMissingItemIA } from "../instantAnswers/ordersAndShipping-reportMissingItem";
import { ReportWrongItemIA } from "../instantAnswers/ordersAndShipping-reportWrongItem";
import { RequestDutiesReimbursementIA } from "../instantAnswers/ordersAndShipping-requestDutiesReimbursement";
import { ShippingCostEstimatesIA } from "../instantAnswers/ordersAndShipping-shippingCostEstimates";
import { UpdateAccountShippingAddressIA } from "../instantAnswers/ordersAndShipping-updateAccountShippingAddress";
import { WhereIsMyOrderIA } from "../instantAnswers/ordersAndShipping-whereIsMyOrder";
import { GeneralContactBrandIA } from "../instantAnswers/shared-generalContactBrand";
export var useOrdersAndShippingRetailerNodes = function useOrdersAndShippingRetailerNodes() {
  var _articles$ImportFeesA, _articles$FAQ$FAIRE_I;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    OrdersAndShipping: {
      id: "OrdersAndShipping",
      label: strictLocalize({
        id: "gPHaRb",
        defaultMessage: [{
          "type": 0,
          "value": "Commandes et expédition"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(ShippingIcon, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["TrackShipment", "DamagedMissingOrWrong", "Returns", "OrdersAndShippingDuties", "ShippingAddresses", "ImportingProducts", "ShippingCosts", "OtherOrdersAndShipping"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "klr0HR",
        defaultMessage: [{
          "type": 0,
          "value": "Problème de commande ou d'expédition"
        }]
      })
    },
    TrackShipment: {
      id: "TrackShipment",
      label: strictLocalize({
        id: "UhFmiI",
        defaultMessage: [{
          "type": 0,
          "value": "Suivi du colis"
        }]
      }),
      children: ["WhereIsMyOrder", "EstimatedShipDate", "ItemDelayed", "OtherTrackShipment"],
      level: 2
    },
    DamagedMissingOrWrong: {
      id: "DamagedMissingOrWrong",
      label: strictLocalize({
        id: "NU3A+j",
        defaultMessage: [{
          "type": 0,
          "value": "Articles ou envois endommagés, manquants ou incorrects"
        }]
      }),
      children: ["ReportDamagedItem", "ReportMissingItem", "WrongItemsSent", "OtherDamagedMissingOrWrong"],
      level: 2
    },
    Returns: {
      id: "Returns",
      label: strictLocalize({
        id: "+Ft0jF",
        defaultMessage: [{
          "type": 0,
          "value": "Retours"
        }]
      }),
      children: ["CreateReturn", "ExtendReturn", "ItemReturnedToBrand", "OtherReturns"],
      level: 2
    },
    OrdersAndShippingDuties: {
      id: "OrdersAndShippingDuties",
      label: strictLocalize({
        id: "TR1PUI",
        defaultMessage: [{
          "type": 0,
          "value": "Droits de douane"
        }]
      }),
      children: ["HowDutiesWork", "OrdersAndShippingDutiesInvoice", "RequestDutiesReimbursement", "OtherOrdersAndShippingDuties"],
      level: 2
    },
    ShippingAddresses: {
      id: "ShippingAddresses",
      label: strictLocalize({
        id: "pwhaZ2",
        defaultMessage: [{
          "type": 0,
          "value": "Adresses de livraison"
        }]
      }),
      children: ["ChangeShippingAddress", "UpdateShippingAddress", "POBox"],
      level: 2
    },
    ImportingProducts: {
      id: "ImportingProducts",
      label: strictLocalize({
        id: "K+bDUx",
        defaultMessage: [{
          "type": 0,
          "value": "Importation de produits"
        }]
      }),
      children: ["GuideToImportingProducts", "EORIDetails", "ImportedItemReturnedToBrand", "OtherImportingProducts"],
      level: 2
    },
    ShippingCosts: {
      id: "ShippingCosts",
      label: strictLocalize({
        id: "L3Y+9t",
        defaultMessage: [{
          "type": 0,
          "value": "Frais de livraison"
        }]
      }),
      children: ["ShippingCostEstimates", "ShippingCostsWithInsider", "OtherShippingCosts"],
      level: 2
    },
    OtherOrdersAndShipping: {
      id: "OtherOrdersAndShipping",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FulfillingOrders.SHIPPING_WORK, articles.FulfillingOrders.SHIPPING_ADDRESS],
      level: 2
    },
    WhereIsMyOrder: {
      id: "WhereIsMyOrder",
      label: strictLocalize({
        id: "DzauqU",
        defaultMessage: [{
          "type": 0,
          "value": "Où est ma commande"
        }]
      }),
      articles: [articles.MyOrders.ORDER_STATUS],
      instantAnswer: WhereIsMyOrderIA(strictLocalize),
      level: 3
    },
    EstimatedShipDate: {
      id: "EstimatedShipDate",
      label: strictLocalize({
        id: "E8y44Q",
        defaultMessage: [{
          "type": 0,
          "value": "Date d'expédition estimée"
        }]
      }),
      articles: [articles.MyOrders.ORDER_STATUS],
      instantAnswer: EstimatedShipDateIA(strictLocalize),
      level: 3
    },
    ItemDelayed: {
      id: "ItemDelayed",
      label: strictLocalize({
        id: "7yIDZV",
        defaultMessage: [{
          "type": 0,
          "value": "Article retardé"
        }]
      }),
      articles: [articles.MyOrders.ORDER_STATUS],
      instantAnswer: ItemDelayedIA(strictLocalize),
      level: 3
    },
    OtherTrackShipment: {
      id: "OtherTrackShipment",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FulfillingOrders.SHIPPING_WORK, articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    ReportDamagedItem: {
      id: "ReportDamagedItem",
      label: strictLocalize({
        id: "T0K88a",
        defaultMessage: [{
          "type": 0,
          "value": "Signaler un article ou un envoi endommagé"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportDamagedItemIA(strictLocalize),
      level: 3
    },
    ReportMissingItem: {
      id: "ReportMissingItem",
      label: strictLocalize({
        id: "RU4RZc",
        defaultMessage: [{
          "type": 0,
          "value": "Signaler un article ou un envoi manquant"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportMissingItemIA(strictLocalize),
      level: 3
    },
    WrongItemsSent: {
      id: "WrongItemsSent",
      label: strictLocalize({
        id: "x13QnE",
        defaultMessage: [{
          "type": 0,
          "value": "Les articles envoyés ne correspondent pas à la commande"
        }]
      }),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: ReportWrongItemIA(strictLocalize),
      level: 3
    },
    OtherDamagedMissingOrWrong: {
      id: "OtherDamagedMissingOrWrong",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.REPORT_DAMAGED_MISSING],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    CreateReturn: {
      id: "CreateReturn",
      label: strictLocalize({
        id: "N8lxVa",
        defaultMessage: [{
          "type": 0,
          "value": "Créer un retour"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN, articles.ReturnsAndRefunds.CANT_RETURN],
      instantAnswer: CreateReturnIA(strictLocalize),
      level: 3
    },
    ExtendReturn: {
      id: "ExtendReturn",
      label: strictLocalize({
        id: "UvRR6c",
        defaultMessage: [{
          "type": 0,
          "value": "Prolonger le délai de retour"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.EXTEND_A_RETURN],
      instantAnswer: ExtendReturnIA(strictLocalize),
      level: 3
    },
    ItemReturnedToBrand: {
      id: "ItemReturnedToBrand",
      label: strictLocalize({
        id: "r1OPuX",
        defaultMessage: [{
          "type": 0,
          "value": "Article retourné à la marque par le transporteur"
        }]
      }),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    OtherReturns: {
      id: "OtherReturns",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ReturnsAndRefunds.MAKE_A_RETURN],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    HowDutiesWork: {
      id: "HowDutiesWork",
      label: strictLocalize({
        id: "ZU+hvD",
        defaultMessage: [{
          "type": 0,
          "value": "Comment fonctionnent les droits de douane ?"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      instantAnswer: HowDutiesWorkIA(strictLocalize, articles),
      level: 3
    },
    OrdersAndShippingDutiesInvoice: {
      id: "OrdersAndShippingDutiesInvoice",
      label: strictLocalize({
        id: "dzM6Bz",
        defaultMessage: [{
          "type": 0,
          "value": "Pourquoi ai-je reçu une facture pour des droits de douane ?"
        }]
      }),
      articles: [(_articles$ImportFeesA = articles.ImportFeesAndDuties.DUTIES_REFUND) === null || _articles$ImportFeesA === void 0 ? void 0 : _articles$ImportFeesA.atSection("0"), (_articles$FAQ$FAIRE_I = articles.FAQ.FAIRE_INSIDER_EU) === null || _articles$FAQ$FAIRE_I === void 0 ? void 0 : _articles$FAQ$FAIRE_I.atSection("6")],
      instantAnswer: DutiesInvoiceIA(strictLocalize),
      level: 3
    },
    RequestDutiesReimbursement: {
      id: "RequestDutiesReimbursement",
      label: strictLocalize({
        id: "Audzui",
        defaultMessage: [{
          "type": 0,
          "value": "Demander le remboursement des droits de douane"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      instantAnswer: RequestDutiesReimbursementIA(strictLocalize, articles),
      level: 3
    },
    OtherOrdersAndShippingDuties: {
      id: "OtherOrdersAndShippingDuties",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ImportFeesAndDuties.DUTIES_REFUND],
      level: 3
    },
    ChangeShippingAddress: {
      id: "ChangeShippingAddress",
      label: strictLocalize({
        id: "PtGtf1",
        defaultMessage: [{
          "type": 0,
          "value": "Modifier l'adresse de livraison d'une commande"
        }]
      }),
      articles: [articles.FulfillingOrders.CHANGE_SHIPPING_ADDRESS],
      instantAnswer: ChangeShippingAddressIA(strictLocalize),
      level: 3
    },
    UpdateShippingAddress: {
      id: "UpdateShippingAddress",
      label: strictLocalize({
        id: "ht5qXQ",
        defaultMessage: [{
          "type": 0,
          "value": "Mettre à jour l'adresse de livraison sur le compte"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: UpdateAccountShippingAddressIA(strictLocalize),
      level: 3
    },
    POBox: {
      id: "POBox",
      label: strictLocalize({
        id: "5TayG5",
        defaultMessage: [{
          "type": 0,
          "value": "Adresses avec des boîtes postales"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: PoBoxIA(strictLocalize),
      level: 3
    },
    GuideToImportingProducts: {
      id: "GuideToImportingProducts",
      label: strictLocalize({
        id: "nCHK96",
        defaultMessage: [{
          "type": 0,
          "value": "Guide d'importation des produits"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.USA, articles.ImportFeesAndDuties.Canada, articles.ImportFeesAndDuties.Europe, articles.ImportFeesAndDuties.Australia],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    EORIDetails: {
      id: "EORIDetails",
      label: strictLocalize({
        id: "u01v/g",
        defaultMessage: [{
          "type": 0,
          "value": "Détails EORI"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.EORI],
      instantAnswer: EoriDetailsIA(strictLocalize),
      level: 3
    },
    ImportedItemReturnedToBrand: {
      id: "ImportedItemReturnedToBrand",
      label: strictLocalize({
        id: "r1OPuX",
        defaultMessage: [{
          "type": 0,
          "value": "Article retourné à la marque par le transporteur"
        }]
      }),
      articles: [articles.ImportFeesAndDuties.USA, articles.ImportFeesAndDuties.Canada, articles.ImportFeesAndDuties.Europe, articles.ImportFeesAndDuties.Australia],
      instantAnswer: GeneralContactBrandIA(strictLocalize),
      level: 3
    },
    OtherImportingProducts: {
      id: "OtherImportingProducts",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.ImportFeesAndDuties.USA, articles.ImportFeesAndDuties.Canada, articles.ImportFeesAndDuties.Europe, articles.ImportFeesAndDuties.Australia],
      level: 3
    },
    ShippingCostEstimates: {
      id: "ShippingCostEstimates",
      label: strictLocalize({
        id: "SS+oQb",
        defaultMessage: [{
          "type": 0,
          "value": "Comprendre les estimations des frais de livraison"
        }]
      }),
      articles: [articles.FulfillingOrders.SHIPPING_WORK],
      instantAnswer: ShippingCostEstimatesIA(strictLocalize),
      level: 3
    },
    ShippingCostsWithInsider: {
      id: "ShippingCostsWithInsider",
      label: strictLocalize({
        id: "5ak7Xv",
        defaultMessage: [{
          "type": 0,
          "value": "Frais de livraison avec Insider"
        }]
      }),
      articles: [articles.FAQ.FAIRE_INSIDER_EU, articles.FAQ.FAIRE_INSIDER_US],
      level: 3
    },
    OtherShippingCosts: {
      id: "OtherShippingCosts",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.FulfillingOrders.SHIPPING_WORK],
      level: 3
    }
  };
};